// Function to get auth key from environment variables
export const getAuthKey = () => {
  if (process.env.REACT_APP_AUTHKEY) {
    return process.env.REACT_APP_AUTHKEY;
  }
  
  // Fallback for development
  return 'AUTHKEYNOTFOUND';
} 